export default __webpack_public_path__ + "static/media/gallery_00.bc38ca50.jpg";